import PositionGroups from "@/assets/js/position-groups";
import { Performance } from "@/assets/js/tactics/pitch/responsibilities";
import Duties from "@/assets/js/duties";


export default class CentralDefence {
  constructor(position) {
    this.position = position;
  }

  get responsibilityPerformance() {
    return {
      attackingCover: this.attackingCover(),
      defensiveCover: this.defensiveCover(),
      defensivePressure: this.defensivePressure(),
      playingSafe: this.playingSafe(),
    };
  }

  attackingCover() {
    const centreBackHoldsPosition = (
      this.position.positionGroup === PositionGroups.centralDefence && 
      this.position.playerInstructions.movement === -1 &&
      this.position.playerInstructions.moveIntoCentralMidfieldInPossession === 0);
    const invertedFullBack = this.position.positionGroup === PositionGroups.fullBack && this.position.playerInstructions.moveIntoCentralDefenceInPossession === 1;

    const contributes = (
      this.position.positionGroup === PositionGroups.centralDefence &&
      this.position.playerInstructions.movement === 0 &&
      this.position.playerInstructions.moveIntoCentralMidfieldInPossession === 0
    );

    return new Performance(
      centreBackHoldsPosition || invertedFullBack,
      contributes,
      false);
  }

  defensiveCover() {
    return new Performance(
      this.position.positionGroup === PositionGroups.centralDefence && this.position.playerInstructions.pressingIntensity <= 0,
      false,
      this.position.positionGroup === PositionGroups.centralDefence && this.position.playerInstructions.movement > 0);
  }

  defensivePressure() {
    return new Performance(
      this.position.positionGroup === PositionGroups.centralDefence && this.position.selectedRole.duty === Duties.stopper,
      this.position.positionGroup === PositionGroups.centralDefence && this.position.selectedRole.duty === Duties.defend,
      false);
  }

  playingSafe() {
    const disciplinedCentreBack = 
        this.position.positionGroup === PositionGroups.centralDefence && 
        this.position.playerInstructions.creativeFreedom <= 0;
    const halfBack = 
        this.position.positionGroup === PositionGroups.defensiveMidfield && 
        this.position.playerInstructions.dropDeepMore === 1;

    return new Performance(
      disciplinedCentreBack || halfBack,
      false,
      false);
  }
}
